(function () {
  'use strict';

  function slugify(str) {
    return (str || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function mediaTags(el, attr) {
    return (el.dataset[attr] || '').split('|').map(slugify).filter(Boolean);
  }

  // ---------- gallery: click a thumbnail, swap the main image / filter by color + size ----------
  document.querySelectorAll('[data-gc-product]').forEach(function (root) {
    var thumbs = root.querySelectorAll('[data-gc-thumbs] .gc-thumb');
    var mainImgs = root.querySelectorAll('[data-gc-main] .gc-main-img');
    var state = { color: null, size: null };

    function setActiveMedia(id) {
      thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.mediaId === id); });
      mainImgs.forEach(function (img) { img.classList.toggle('active', img.dataset.mediaId === id); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { setActiveMedia(thumb.dataset.mediaId); });
    });

    // una foto sin color/tamaño asignado se ve siempre; una foto que SÍ es la
    // "foto de la variante" de una combinación específica (en Shopify Admin,
    // Producto → Variantes → esa fila → foto) solo se ve cuando el color y el
    // tamaño elegidos arriba coinciden con esa variante
    function isVisible(el) {
      var colors = mediaTags(el, 'colors');
      var sizes = mediaTags(el, 'sizes');
      var colorOk = !state.color || colors.length === 0 || colors.indexOf(slugify(state.color)) !== -1;
      var sizeOk = !state.size || sizes.length === 0 || sizes.indexOf(slugify(state.size)) !== -1;
      return colorOk && sizeOk;
    }

    function applyFilters() {
      var visibleIds = [];
      var wouldBeVisible = Array.prototype.map.call(thumbs, isVisible);
      // si la combinación elegida no tiene ninguna foto propia (ej: no existe
      // esa variante), mejor mostrar todas que dejar la galería vacía
      var noneVisible = wouldBeVisible.length > 0 && wouldBeVisible.indexOf(true) === -1;

      thumbs.forEach(function (t, i) {
        var visible = noneVisible ? true : wouldBeVisible[i];
        t.classList.toggle('gc-media-hidden', !visible);
        if (visible) visibleIds.push(t.dataset.mediaId);
      });
      mainImgs.forEach(function (img) {
        var visible = noneVisible ? true : isVisible(img);
        img.classList.toggle('gc-media-hidden', !visible);
      });
      var activeThumb = root.querySelector('[data-gc-thumbs] .gc-thumb.active');
      var activeStillVisible = activeThumb && visibleIds.indexOf(activeThumb.dataset.mediaId) !== -1;
      if (!activeStillVisible && visibleIds.length) setActiveMedia(visibleIds[0]);
    }

    document.addEventListener('gc:color-change', function (event) { state.color = event.detail.value; applyFilters(); });
    document.addEventListener('gc:size-change', function (event) { state.size = event.detail.value; applyFilters(); });

    // ---------- info tabs: Descripción / Detalles ----------
    var tabBtns = root.querySelectorAll('[data-gc-tab]');
    var tabPanels = root.querySelectorAll('[data-gc-panel]');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabBtns.forEach(function (b) { b.classList.toggle('active', b === btn); });
        tabPanels.forEach(function (p) { p.classList.toggle('active', p.dataset.gcPanel === btn.dataset.gcTab); });
      });
    });
  });

  // ---------- variant picker: update hidden id / price / add-button, no page reload ----------
  customElements.define(
    'gc-product-form',
    class GcProductForm extends HTMLElement {
      connectedCallback() {
        this.variants = [];
        var script = this.querySelector('[data-gc-variants]');
        if (script) {
          try { this.variants = JSON.parse(script.textContent); } catch (e) { this.variants = []; }
        }
        this.idInput = this.querySelector('.product-variant-id');
        this.submitBtn = this.querySelector('.product-form__submit');
        this.submitLabel = this.submitBtn ? this.submitBtn.querySelector('span') : null;
        this.priceEl = this.closest('.gc-product__buybox') ? this.closest('.gc-product__buybox').querySelector('[data-gc-price]') : null;

        this.addEventListener('change', this.onOptionChange.bind(this));

        this.refreshAvailability();
        this.syncFromSelection(true);
      }

      currentVariant() {
        var selected = Array.prototype.map.call(
          this.querySelectorAll('[data-gc-option-input]:checked'),
          function (el) { return el.value; }
        );
        return this.variants.filter(function (v) {
          return selected.every(function (val) {
            return v.option1 === val || v.option2 === val || v.option3 === val;
          });
        })[0] || null;
      }

      setSubmitLabel(text) {
        if (this.submitLabel) this.submitLabel.textContent = text;
      }

      // La talla siempre manda: se ve y se puede elegir siempre, sin excepción
      // (si no, alguien podría quedar "atrapado" en un color cuya talla grande
      // no existe, sin ver cómo volver). El color es el que depende de la
      // talla elegida: si esa combinación nunca existió, se oculta; si existe
      // pero no hay stock, se ve tachada y deshabilitada. Si el color elegido
      // actualmente queda oculto, se selecciona automáticamente el primero
      // disponible para la talla actual.
      refreshAvailability() {
        var self = this;
        var groups = {};
        this.querySelectorAll('[data-gc-option-input]').forEach(function (input) {
          var name = input.dataset.optionName;
          (groups[name] = groups[name] || []).push(input);
        });
        var groupNames = Object.keys(groups);
        if (groupNames.length < 2) return; // nada que cruzar con un solo grupo de opciones

        // grupos "dependientes" = todo lo que NO sea la talla (data-gc-size-option)
        var dependentNames = groupNames.filter(function (name) {
          return !groups[name][0].hasAttribute('data-gc-size-option');
        });

        function currentSelection() {
          var current = {};
          groupNames.forEach(function (name) {
            var checked = groups[name].filter(function (i) { return i.checked; })[0];
            current[name] = checked ? checked.value : null;
          });
          return current;
        }

        dependentNames.forEach(function (name) {
          var others = groupNames.filter(function (n) { return n !== name; });
          var current = currentSelection();
          var firstAvailable = null;
          var firstAny = null;
          var checkedInput = null;
          var checkedStillExists = false;

          groups[name].forEach(function (input) {
            var label = input.nextElementSibling;
            var variant = self.variants.filter(function (v) {
              var matchesOthers = others.every(function (on) {
                var val = current[on];
                return val === null || v.option1 === val || v.option2 === val || v.option3 === val;
              });
              var matchesSelf = v.option1 === input.value || v.option2 === input.value || v.option3 === input.value;
              return matchesOthers && matchesSelf;
            })[0];

            var exists = !!variant;
            var available = exists && variant.available;

            input.hidden = !exists;
            if (label) {
              label.classList.toggle('gc-opt-hidden', !exists);
              label.classList.toggle('gc-opt-soldout', exists && !available);
            }
            input.disabled = !exists || !available;

            if (exists) {
              if (!firstAny) firstAny = input;
              if (available && !firstAvailable) firstAvailable = input;
            }
            if (input.checked) {
              checkedInput = input;
              checkedStillExists = exists;
            }
          });

          if (checkedInput && !checkedStillExists) {
            var fallback = firstAvailable || firstAny;
            if (fallback && fallback !== checkedInput) {
              checkedInput.checked = false;
              fallback.checked = true;
            }
          }
        });
      }

      syncFromSelection(isInitial) {
        var variant = this.currentVariant();
        if (variant) {
          if (this.idInput) {
            this.idInput.value = variant.id;
            this.idInput.disabled = !variant.available;
          }
          if (this.submitBtn) this.submitBtn.disabled = !variant.available;
          this.setSubmitLabel(variant.available ? 'Añadir' : 'Agotado');
          if (this.priceEl) this.priceEl.textContent = variant.price_formatted;
        } else {
          // esto ya solo debería pasar si el producto tiene una sola opción —
          // con 2+ opciones, refreshAvailability() ya evita que se pueda armar
          // una combinación que no exista
          if (this.idInput) this.idInput.disabled = true;
          if (this.submitBtn) this.submitBtn.disabled = true;
          this.setSubmitLabel('No disponible');
          if (this.priceEl) this.priceEl.textContent = 'No disponible';
        }

        var sizeInput = this.querySelector('[data-gc-size-option]:checked');
        if (sizeInput) this.broadcastSize(sizeInput.value, !!isInitial);

        var colorInput = this.querySelector('[data-gc-color-option]:checked');
        if (colorInput) this.broadcastColor(colorInput.value);
      }

      onOptionChange(event) {
        if (!event.target.matches('[data-gc-option-input]')) return;
        this.refreshAvailability();
        this.syncFromSelection(false);
      }

      broadcastColor(value) {
        if (!value) return;
        document.dispatchEvent(new CustomEvent('gc:color-change', { detail: { value: value } }));
      }

      broadcastSize(value, isInitial) {
        if (!value) return;
        document.dispatchEvent(new CustomEvent('gc:size-change', {
          detail: { value: value, key: slugify(value), initial: !!isInitial }
        }));
      }
    }
  );
})();
